<template>
  <sideBarView />

  <navbarView />

  <main class="main-sec" id="main">
    <div class="container">
      <div class="flex-bet-main mb-2">
        <div class="side-heading">
          <h6>
            <router-link :to="'/buildingDetails/' + route.params.id" class="black">{{ route.query.name  }}</router-link> /
            <span class="color-main">{{ $t('tenant.tenantsBreadcrumb') }}</span>
          </h6>
          <p class="font13 gray-col">
            {{ $t('tenant.viewSubtitle') }}
          </p>
        </div>
        <router-link
          :to="{ name: 'addTenant', params: { id: route.params.id } }"
          class="main-btn up"
          >{{ $t('tenant.addTenantBtn') }}</router-link
        >
      </div>
      <div class="tenantsView" v-if="newOrders.length">
        <dataTable
          :tableData="newOrders"
          :showLink="true"
          :HeadOfTable="HeadOfTable"
          linkDirection="tenantDetails"
        />
      </div>
      <div class="noTenants" v-else>
        <div class="flex-group-me mb-3">
          <img :src="noTenantsImg" class="noTenants" alt="" />
        </div>
        <div class="text-center font-bold">{{ $t('tenant.noTenantsYet') }}</div>
      </div>
    </div>
  </main>
</template>

<script setup>
// imports
import sideBarView from "../components/dashboard/sideBarView.vue";
import navbarView from "../components/dashboard/navbarView.vue";
import dataTable from "../components/dashboard/dataTable.vue";
const route = useRoute();
import { useRoute } from "vue-router";
import axios from "axios";
import { ref, onMounted } from "vue";
import { useI18n } from "vue-i18n";


const { t } = useI18n();

// reactive state
const HeadOfTable = ref([
  {
    headText: t('tenant.serialNumber'),
    headKey: "id",
  },
  {
    headText: t('tenant.tenantName'),
    headKey: "user_name",
  },
  {
    headText: t('tenant.phoneNumber'),
    headKey: "user_phone",
  },
  {
    headText: t('tenant.rentDuration'),
    headKey: "period",
  },

  {
    headText: t('tenant.startDate'),
    headKey: "start",
  },
  {
    headText: t('tenant.endDate'),
    headKey: "end",
  },
  {
    headText: t('tenant.rentAmountField'),
    headKey: "price",
  },
  {
    headText: t('tenant.rentPeriodField'),
    headKey: "period",
  },
  {
    headText: t('tenant.remainingDays'),
    headKey: "remaining_days",
  },
]);
const newOrders = ref([]);
const noTenantsImg = ref(require("../assets/imgs/Group 179171.png"));
// functions
function getTenants() {
  axios
    .get(`/manager/rentals/${route.params.id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then((response) => {
      newOrders.value = response.data.data;
      console.log(response.data.data);
    });
}

// lifecycle hooks
onMounted(() => {
  getTenants();
});
</script>
